import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/Contemporary_Period_-_Digital_Revolution.png';

function HistoryPageDigitalRevolution() {
  return (
    <TopicPage
      topicKey="Digital Revolution"
      title="History: Digital Revolution"
      backgroundImage={bg}
      startRoute="/History-Digital-Revolution-Go"
      scrollLabels={[
        "Rise of the Internet",
        "Tech Giants and Innovation",
        "Social Media and Global Impact"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageDigitalRevolution;
